import * as types from "../actions/viewManagerTypes";
import * as actions from "../actions/viewManagerActions";

import { call, put, takeEvery } from 'redux-saga/effects';
import axiosInstance from '../../interceptor/interceptor.js'; 


const fetchEmployeesApi = () =>  axiosInstance.get('emp/list/3'); 

function* fetchManagers() {
  try {
    const response = yield call(fetchEmployeesApi);
    yield put(actions.fetchManagersSuccess(response.data.employees));
  } catch (error) {
    yield put(actions.fetchManagersFailure(error.message));
  }
}

function* rootSaga() {
  yield takeEvery(types.FETCH_MANAGER_REQUEST, fetchManagers);
}

export default rootSaga;
